import React from 'react'
import { Column } from 'react-virtualized'
import moment from 'moment'
import { checkIdtfFeatureEnabled } from 'configs'

import Table from '../../../containers/Tables/components/Table'
import TableStyles from '../../../containers/Tables/components/Table/Table.css'
import TableHeader from '../../../containers/Tables/components/TableHeader'
import TableActions from '../../../containers/Tables/components/TableActions'
import TableActionStyles from '../../../containers/Tables/components/TableActions/TableActions.css'
import { DatePopover, DropdownSearchPopover, SearchPopover, MultiSelectListPopover } from '../../../containers/Popovers'
import styles from './EnrollmentTable.css'
import { DATE_WIDTH } from '../../../containers/Tables/Utilities'
import { getDateFormat, ENROLLMENT_TABLE_COLUMN_HEADERS, TABLE_CHECKBOX_WIDTH } from '../../../constants'

class EnrollmentTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: {},
      isAnySelected: false,
    }
  }

  dateFormat = getDateFormat(this.props.me)

  handleOnSelectionClick = selected => {
    const {
      onSelectionClick,
    } = this.props

    const isAnySelected = Object.keys(selected).some(key => selected[key] === true)

    this.setState({
      selected,
      isAnySelected,
    })

    if (typeof onSelectionClick === 'function') {
      onSelectionClick(selected)
    }
  }

  render() {
    const {
      noDataText = 'No records found.',
      enableLoader,
      showLoader,
      rowHeight,
      data,
      idtfEnrollments,
      showRowSelection = false,
      width,
      onRowClick,
      sortBy,
      sortDirection,
      filterStartDate,
      filterEndDate,
      filterPrescription,
      filterIcd10Code,
      filterBillingCode,
      filterOrderNumber,
      handleOnFilterButtonClick,
      handleOnFilterChange,
      handleOnSortClick,
      handleOnOutsidePopoverClick,
      handleOnPopoverKeyUp,
      selectedPopover,

      selectedStartStartDate,
      selectedStartEndDate,
      startDateRange,

      selectedEndStartDate,
      selectedEndEndDate,
      endDateRange,

      selectedPrescriptionId,
      prescriptions,

      selectedIcd10CodeId,
      icd10Codes,

      selectedBillingCode,
      billingCodes,

      selectedOrderNumber,
    } = this.props
    const {
      selected,
      isAnySelected,
    } = this.state

    let idtfData = []
    idtfData = idtfEnrollments && idtfEnrollments.data && idtfEnrollments.data
    const isIdtfEnabled = checkIdtfFeatureEnabled(this.props.me)
    const ROW_HEIGHT = rowHeight
    const START_DATE_WIDTH = DATE_WIDTH
    const END_DATE_WIDTH = DATE_WIDTH
    const ICD10_CODE_WIDTH = 190
    const BILLING_CODE_WIDTH = 190
    const ORDER_NUMBER_WIDTH = 190
    let prescriptionWidth = width - START_DATE_WIDTH - END_DATE_WIDTH - ICD10_CODE_WIDTH - BILLING_CODE_WIDTH - ORDER_NUMBER_WIDTH

    if (showRowSelection) {
      prescriptionWidth -= TABLE_CHECKBOX_WIDTH
    }

    let selectedPrescription
    let prescriptionsOptions

    if (prescriptions && prescriptions.data) {
      prescriptionsOptions = prescriptions.data.sortedByName.map(id => prescriptions.data.byId[id])
      selectedPrescription = selectedPrescriptionId && prescriptions.data.byId[selectedPrescriptionId]
    }

    let billingCodesOptions

    if (billingCodes && billingCodes.data) {
      billingCodesOptions = billingCodes.data.sortedByName.map(id => billingCodes.data.byId[id])
    }

    let selectedIcd10Code
    let icd10CodesOptions

    if (icd10Codes && icd10Codes.data) {
      icd10CodesOptions = icd10Codes.data.sortedByName.map(id => icd10Codes.data.byId[id])
      selectedIcd10Code = selectedIcd10CodeId && icd10Codes.data.byId[selectedIcd10CodeId]
    }

    return (
      <div className={styles.enrollmentTable}>
        <Table
          noDataText={noDataText}
          enableLoader={enableLoader}
          showLoader={showLoader}
          showRowSelection={showRowSelection}
          // headerHeight={35}
          rowHeight={ROW_HEIGHT}
          uniqueKey="code"
          hasTableActions={isAnySelected}
          onSelectionClick={this.handleOnSelectionClick}
          onRowClick={onRowClick}
          data={isIdtfEnabled ? idtfData : data}
          sortBy={sortBy}
          sortDirection={sortDirection}
        >
          <Column
            className={TableStyles.column}
            label="Start Date"
            dataKey={ENROLLMENT_TABLE_COLUMN_HEADERS.START_DATE}
            width={START_DATE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={ENROLLMENT_TABLE_COLUMN_HEADERS.START_DATE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterStartDate}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={showRowSelection ? styles.startDatePopoverWithSelection : styles.startDatePopover}>
                      <DatePopover
                        handleOnChange={dates => handleOnFilterChange(ENROLLMENT_TABLE_COLUMN_HEADERS.START_DATE, dates)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        min={startDateRange[0]}
                        max={startDateRange[1]}
                        startDate={selectedStartStartDate}
                        endDate={selectedStartEndDate}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const enrollment = rowData
              const date = enrollment.startDate && moment(enrollment.startDate).format(this.dateFormat)
              return (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={`${TableStyles.primaryText} ${TableStyles.centeredText}`}>
                    {date}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="End Date"
            dataKey={ENROLLMENT_TABLE_COLUMN_HEADERS.END_DATE}
            width={END_DATE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={ENROLLMENT_TABLE_COLUMN_HEADERS.END_DATE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterEndDate}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.endDatePopover}>
                      <DatePopover
                        handleOnChange={dates => handleOnFilterChange(ENROLLMENT_TABLE_COLUMN_HEADERS.END_DATE, dates)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        min={endDateRange[0]}
                        max={endDateRange[1]}
                        startDate={selectedEndStartDate}
                        endDate={selectedEndEndDate}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const enrollment = rowData
              const date = enrollment.endDate && moment(enrollment.endDate).format(this.dateFormat)

              return (
                <div className={TableStyles.centeredColumnContent}>
                  <p className={`${TableStyles.primaryText} ${TableStyles.centeredText}`}>
                    {date}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Connection Plan"
            dataKey={ENROLLMENT_TABLE_COLUMN_HEADERS.PRESCRIPTION}
            width={prescriptionWidth}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={ENROLLMENT_TABLE_COLUMN_HEADERS.PRESCRIPTION}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterPrescription}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={showRowSelection ? styles.prescriptionPopoverWithSelection : styles.prescriptionPopover}>
                      <DropdownSearchPopover
                        noResultsMessage="No connection plan found"
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        placeholder="Connection Plan..."
                        isLoading={prescriptions && prescriptions.isFetching}
                        options={prescriptionsOptions}
                        value={selectedPrescription}
                        onChange={prescription => handleOnFilterChange(ENROLLMENT_TABLE_COLUMN_HEADERS.PRESCRIPTION, prescription)}
                        getOptionLabel={p => p.name || ''}
                        getOptionValue={d => d.id}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const enrollment = rowData
              const text = isIdtfEnabled ? `${enrollment.serviceType} + ${enrollment.device} (${enrollment.duration} Days)` : enrollment.connectionTemplateName || ''
              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {text}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="ICD10 Code"
            dataKey={ENROLLMENT_TABLE_COLUMN_HEADERS.ICD10_CODE}
            width={ICD10_CODE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={ENROLLMENT_TABLE_COLUMN_HEADERS.ICD10_CODE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterIcd10Code}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.icd10CodesPopover}>
                      <DropdownSearchPopover
                        noResultsMessage="No ICD10 code found"
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        placeholder="ICD10 Code..."
                        isLoading={icd10Codes && icd10Codes.isFetching}
                        options={icd10CodesOptions}
                        value={selectedIcd10Code}
                        onChange={icd10Code => handleOnFilterChange(ENROLLMENT_TABLE_COLUMN_HEADERS.ICD10_CODE, icd10Code)}
                        getOptionLabel={p => p.name}
                        getOptionValue={d => d.id}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const enrollment = rowData
              const text = enrollment.icd10Codes && enrollment.icd10Codes.length > 0
                ? enrollment.icd10Codes[0].name
                : ''

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {text}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="Billing Code"
            dataKey={ENROLLMENT_TABLE_COLUMN_HEADERS.BILLING_CODE}
            width={BILLING_CODE_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={ENROLLMENT_TABLE_COLUMN_HEADERS.BILLING_CODE}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterBillingCode}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.billingCodesPopover}>
                      <MultiSelectListPopover
                        list={billingCodesOptions}
                        selected={selectedBillingCode}
                        getOptionLabel={d => d.name}
                        getOptionValue={d => d.id}
                        enableSearch={false}
                        handleOnClick={billingCode => handleOnFilterChange(ENROLLMENT_TABLE_COLUMN_HEADERS.BILLING_CODE, billingCode)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const enrollment = rowData
              const text = enrollment.billingCodes && enrollment.billingCodes.length > 0
                ? enrollment.billingCodes[0].name
                : ''

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {text}
                  </p>
                </div>
              )
            }}
          />
          <Column
            className={TableStyles.column}
            label="EHR Order Number"
            dataKey={ENROLLMENT_TABLE_COLUMN_HEADERS.ORDER_NUMBER}
            width={ORDER_NUMBER_WIDTH}
            headerRenderer={headerProps => {
              const {
                label,
              } = headerProps

              return (
                <TableHeader
                  label={label}
                  columnHeader={ENROLLMENT_TABLE_COLUMN_HEADERS.ORDER_NUMBER}
                  handleOnSortClick={handleOnSortClick}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  filterActive={filterOrderNumber}
                  sortBy={sortBy}
                  sortDirection={sortDirection}
                  selectedPopover={selectedPopover}
                  Popover={(
                    <div className={styles.orderNumberPopover}>
                      <SearchPopover
                        handleOnPopoverKeyUp={handleOnPopoverKeyUp}
                        handleOnChange={orderNumber => handleOnFilterChange(ENROLLMENT_TABLE_COLUMN_HEADERS.ORDER_NUMBER, orderNumber)}
                        handleOnOutsidePopoverClick={handleOnOutsidePopoverClick}
                        value={selectedOrderNumber}
                        placeholder="EHR Order Number..."
                      />
                    </div>
                  )}
                />
              )
            }}
            cellRenderer={({ dataKey, rowData }) => {
              const enrollment = rowData
              const text = enrollment.orderNumber || ''

              return (
                <div className={TableStyles.columnContent}>
                  <p className={TableStyles.primaryText}>
                    {text}
                  </p>
                </div>
              )
            }}
          />
        </Table>
      </div>
    )
  }
}

export default EnrollmentTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/EnrollmentTable/EnrollmentTable.jsx